import React, { useEffect, useState } from 'react';
import { useAtom } from 'jotai/index';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import styles from './css/index.module.scss';
import PageTitle from '../../components/PageTitle';
import MyTable from '../../components/MyTable';
import { NICKNAMES_HEADERS } from '../../constants/tables';
import MyInput from '../../components/MyInput';
import { nicknamesAtom, nicknamesFiltersAtom, selectedNicknameAtom } from '../../atoms/nicknamesAtoms';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../api';
import RightArrowBlue from '../../assets/icons/rightArrowBlue.svg';
import TonIcon from '../../assets/icons/ton.svg';
import RightArrow from '../../assets/icons/arrowRight.svg';
import EmptyHeight from '../../components/EmptyHeight';
import convertPrice from '../../helpers/convertPrice';
import { DEFAULT_USERNAMES } from '../../mock/usernames';
import MyLoading from '../../components/MyLoading';
import {
  myNumbersFiltersAtom, numbersAtom, numbersFiltersAtom, selectedNumberAtom,
} from '../../atoms/numbersAtoms';
import convertPhoneNumber from '../../helpers/convertPhoneNumber';
import useTranslations from '../../hooks/useTranslations';
import { DICTIONARY } from '../../translations/dictionary';

function Numbers() {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [nicknamesFilters, setNicknamesFilters] = useAtom(numbersFiltersAtom);
  const [selectedNickname, setSelectedNickname] = useAtom(selectedNumberAtom);
  const [nicknames, setNicknames] = useAtom(numbersAtom);
  const [nicknamesLoading, setNicknamesLoading] = useState(false);

  const onNicknameClick = (nickname) => {
    setSelectedNickname(nickname);
    navigate('/numbers/single');
  };

  return (
    <div className={styles.wrapper}>
      <p className={styles.header}>{t(DICTIONARY.buyAndSellNumbers)}</p>
      <p className={styles.headerInfo}>
        {t(DICTIONARY.buyAndSellNumbersInfo)}
        <Link
          to="/about"
        >
          {t(DICTIONARY.learn)}
          <img src={RightArrowBlue} alt=">" />
        </Link>
      </p>

      <EmptyHeight height={30} />
      <div className={styles.tableHeader}>
        <p className={styles.tableHeaderTitle}>{t(DICTIONARY.topNumbersForSale)}</p>
        {nicknamesLoading && <MyLoading />}
      </div>
      <div className={styles.table}>
        <div className={classNames(styles.tableRow, styles.title)}>
          <span className={styles.titleSpan} style={{ width: '60%' }}>{t(DICTIONARY.anonymousNumbers)}</span>
          <span className={styles.titleSpan} style={{ width: '32%' }}>{t(DICTIONARY.minimalPrice)}</span>
        </div>
        {nicknames.map((item) => (
          <div className={classNames(styles.tableRow)} key={item._id} onClick={() => onNicknameClick(item)}>
            <div className={styles.tableItem} style={{ width: '60%' }}>
              <span className={styles.tableItemMain}>
                {convertPhoneNumber(item.phoneNumber)}
              </span>
            </div>
            <div className={styles.tableItem} style={{ width: '32%' }}>
              <div className={styles.priceRow}>
                <img src={TonIcon} alt="V" className={styles.tonIcon} />
                <span className={styles.tableItemMain}>
                  {convertPrice(item.price)}
                </span>
              </div>
            </div>
            <div className={styles.tableItem} style={{ width: '8%' }}>
              <img src={RightArrow} alt=">" className={styles.rightArrowIcon} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Numbers;
